'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');let

BaseController=function(){
function BaseController(annotationService,$timeout,$scope){_classCallCheck(this,BaseController);
annotationService.applyTo(this);
if(_.exists($timeout)){
this._triggerDigest=function(){return $timeout(_.noop)};
}
if(_.exists($scope)){
this._$scope=$scope;
}
}BaseController.prototype.





_safeWatch=function _safeWatch(prop,func){
this._$scope.$watch(`controller.${prop}`,function(newVal,oldVal){
if(!_.exists(newVal)||newVal===oldVal){
return;
}
func(newVal,oldVal);
});
};_createClass(BaseController,null,[{key:'type',get:function(){return'controller'}}]);return BaseController}();


module.exports=BaseController;
//# sourceMappingURL=baseController.js.map
